import React from "react";

export const TermsAndConditions = (props: any) => {
  return (
    <div>
      <h1>SITE UNDER DEVELOPMENT</h1>
    </div>
  );
};
